import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import EditServiceOrdersForm from './TransferStockItemsForm'
import ModalHeader from './ModalHeader'

const TransferStockItemsModal = props => {
  return (
    <ControlledModal height="auto" width="95rem" noPadding {...props}>
      <ModalHeader />

      <EditServiceOrdersForm />
    </ControlledModal>
  )
}

export default TransferStockItemsModal
